import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import {
  deleteTrainingVideo,
  getGeneratedVideoUrl,
  getTrainingVideo,
} from "../../../actions/Training";
import Training from "../components/Training";
import {
  DeleteTrainingVideoActionDispatchTypes,
  GetGeneratedVideoUrlActionDispatchTypes,
  GetTrainingVideoActionDispatchTypes,
  PostTrainingVideoActionDispatchTypes,
  PutTrainingVideoActionDispatchTypes,
} from "../../../constants/Training";
import { postUserPageTrack } from "../../../actions/UserAction";
import { UserPageTrack } from "../../../models/User";

const mapStateToProps = ({
  trainingVideoState,
  loggedInUserState,
  deleteTrainingVideoState,
  addTrainingVideoState,
  generatedVideoUrlState,
  editTrainingVideoState,
  masterFeatureAccessState
}: ApplicationState) => ({
  trainingVideoList: trainingVideoState.response,
  loggedInUser: loggedInUserState.response,
  deleteTrainingVideoState: deleteTrainingVideoState.response,
  addTrainingVideoState: addTrainingVideoState.response,
  generatedVideoUrl: generatedVideoUrlState.response,
  editTrainingVideoState: editTrainingVideoState.response,
  masterFeatureAccessState: masterFeatureAccessState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getTrainingVideo: () => {
      dispatch(getTrainingVideo());
    },
    deleteTrainingVideo: (videoId: number) => {
      dispatch(deleteTrainingVideo(videoId));
    },
    getGeneratedVideoUrl: (url: string) => {
      dispatch(getGeneratedVideoUrl(url));
    },
    resetGetTrainingVideo: () => {
      dispatch({
        type: GetTrainingVideoActionDispatchTypes.GET_TRAINING_VIDEO_RESET,
      });
    },
    resetDeleteTrainingVideo: () => {
      dispatch({
        type: DeleteTrainingVideoActionDispatchTypes.DELETE_TRAINING_VIDEO_RESET,
      });
    },
    resetPostTrainingVideo: () => {
      dispatch({
        type: PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_RESET,
      });
    },
    resetGeneratedVideoUrl: () => {
      dispatch({
        type: GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_RESET,
      });
    },
    resetPutTrainingVideo: () => {
      dispatch({
        type: PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_RESET,
      });
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Training);
